import { filter, result } from 'lodash';
import { getJSON, baseUrl, postJSON, putJSON, deleteJSON } from './RestHandler';

function _resolveApiUrl(url) {
    return new URL('/api/' + url, baseUrl).toString();
}

let dataService = {
    firestore: {
        collection: (collectionPath: String) => {
            let get = () => {
                if (returnObj.filter.length > 0) {
                    return dataServicePostJson(collectionPath, {
                        Filter: returnObj.filter,
                        OrderBy: returnObj.sort,
                        limit: returnObj.limitPage,
                        startAt: returnObj.startAtPage
                    });
                } else return dataServiceGetJson(collectionPath);
            };

            let deleteData = () => {
                if (returnObj.filter.length > 0) {
                    return dataServiceDeleteJson(collectionPath, {
                        Filter: returnObj.filter
                    });
                } else return dataServiceDeleteJson(collectionPath);
            };
            const returnObj = {
                filter: [],
                sort: [],
                startAtPage: 0,
                limitPage: 0,
                where: (fieldPath, opStr, value) => {
                    returnObj.filter.push({ fieldPath, opStr, value });
                    return returnObj;
                },
                orderBy: (fieldPath) => {
                    returnObj.sort.push({ fieldPath });
                    return returnObj;
                },
                startAt: (start: number) => {
                    returnObj.startAt = start;
                    return returnObj;
                },
                limit: (count: number) => {
                    returnObj.limit = count;
                    return returnObj;
                },
                get,
                delete: deleteData,
                set: (data) => {
                    return dataServicePutJson(collectionPath, data);
                },
                doc: (documentPath: String) => {
                    return {
                        get: () => {
                            return dataServiceGetJson(
                                collectionPath + '/' + documentPath
                            );
                        },
                        set: (data) => {
                            return dataServicePutJson(
                                collectionPath + '/' + documentPath,
                                data
                            );
                        },
                        delete: () => {
                            return dataServiceDeleteJson(
                                collectionPath + '/' + documentPath
                            );
                        }
                    };
                }
            };
            return returnObj;
        },
        doc: (documentPath: String) => {
            return {
                get: () => {
                    return dataServiceGetJson(documentPath);
                },
                set: (data) => {
                    return dataServicePutJson(documentPath, data);
                }
            };
        }
    },
    storage: {}
};

function dataServiceGetJson(resourcePath: String) {
    return getJSON(_resolveApiUrl(resourcePath)).then((result) =>
        dataServiceGetData(result)
    );
}

function dataServicePostJson(resourcePath: String, param, callback) {
    //param && param._id && delete param._id;
    return postJSON(
        _resolveApiUrl(resourcePath),
        param,
        callback
    ).then((result) => dataServiceGetData(result));
}

function dataServicePutJson(resourcePath: String, param, callback) {
    // param && param._id && delete param._id;
    return putJSON(
        _resolveApiUrl(resourcePath),
        param,
        callback
    ).then((result) => dataServiceGetData(result));
}

function dataServiceDeleteJson(resourcePath: String, param) {
    return deleteJSON(_resolveApiUrl(resourcePath), param).then((result) =>
        dataServiceGetData(result)
    );
}

function dataServiceGetData(result) {
    if (Array.isArray(result)) {
        result.forEach((element) => {
            element.data = () => {
                return element;
            };
        });
        return result;
    } else {
        return {
            exists: result ? true : false,
            data: () => {
                return result;
            }
        };
    }
}

export { dataService };



// WEBPACK FOOTER //
// ./demo/src/dataService.js